/*
 * Author: tom
 * Time: 2023/04/13
 */

/**
 * 函数防抖 (只执行最后一次点击)
 * @param fn
 * @param delay
 * @returns {Function}
 */
export function debounce(fn, t) {
  let delay = t || 500;
  let timer;
  return function() {
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      timer = null;
      fn.apply(this, args);
    }, delay);
  }
};
/**
 * 函数节流
 * @param fn
 * @param interval
 * @returns {Function}
 */

export function throttle(fn, t) {
  let last;
  let timer;
  let interval = t || 500;
  return function() {
    let args = arguments;
    let now = +new Date();
    if (last && now - last < interval) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        last = now;
        fn.apply(this, args);
      }, interval);
    } else {
      last = now;
      fn.apply(this, args);
    }
  }
}

/**
 * defer列表处理
 * @param number
 * @returns {Funtion}
 */
export function useDefer(maxFrameCount = 1000) {
  const frameCount = 0;
  const refreshFrameCount = () => {
    requestAnimationFrame(() => {
      frameCount++;
      if (frameCount < maxFrameCount) {
        refreshFrameCount()
      }
    })
  }
  refreshFrameCount()
  return function(showInFrameCount) {
    return frameCount >= showInFrameCount
  }
}
